"use client";

import React, { useState } from 'react';
import { Flex, Box } from '@chakra-ui/react';
import SOPDeviationCard from './SOPDeviationCard';
import DealSentimentCard from './DealSentimentCard';
import CallQualityCard from './CallQualityCard';
import TimeRangeSelector from './TimeRangeSelector';

interface MetricsOverviewProps {
  businessIdentifier?: string;
  timeRange?: string;
  projectData?: {
    sopDeviation?: {
      value: number;
      trend: string;
      trendValue: string;
      trendDirection: 'up' | 'down';
    };
    dealSentiment?: {
      value: number;
      trend: string;
      trendValue: string;
      trendDirection: 'up' | 'down';
    };
    callQuality?: {
      value: number;
      trend: string;
      trendValue: string;
      trendDirection: 'up' | 'down';
    };
  };
}

const MetricsOverview: React.FC<MetricsOverviewProps> = ({ 
  businessIdentifier, 
  projectData, 
  timeRange: propTimeRange 
}) => {
  const [internalTimeRange, setInternalTimeRange] = useState('7d');
  const timeRange = propTimeRange || internalTimeRange;
  
  const sopData = projectData?.sopDeviation;
  const dealData = projectData?.dealSentiment;
  const callData = projectData?.callQuality;

  return (
    <Box>
      {!propTimeRange && (
        <Box mb={4} display="flex" justifyContent="flex-end">
          <TimeRangeSelector 
            value={timeRange} 
            onChange={setInternalTimeRange} 
          />
        </Box>
      )}
      
      <Flex 
        gap={6} 
        flexWrap={{ base: "wrap", md: "nowrap" }}
        justify="space-between"
      >
        <SOPDeviationCard
          businessIdentifier={businessIdentifier}
          timeRange={timeRange}
          value={sopData?.value}
          trend={sopData?.trend}
          trendValue={sopData?.trendValue}
          trendDirection={sopData?.trendDirection}
        />
        <DealSentimentCard 
          businessIdentifier={businessIdentifier}
          timeRange={timeRange}
          value={dealData?.value}
          trend={dealData?.trend}
          trendValue={dealData?.trendValue}
          trendDirection={dealData?.trendDirection}
        />
        <CallQualityCard 
          businessIdentifier={businessIdentifier}
          timeRange={timeRange}
          value={callData?.value}
          trend={callData?.trend}
          trendValue={callData?.trendValue}
          trendDirection={callData?.trendDirection}
        />
      </Flex>
    </Box>
  );
};

export default MetricsOverview; 